import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import Select from "react-select";

const RetriggerJlgEmiPendingModal = ({
  show,
  handleClose,
  handleConfirm,
  comment,
  setComment,
  retriggerToRole,
  setRetriggerToRole,
  roleId,
}) => {
  const [validationError, setValidationError] = useState("");
  const options = [];

  if (
    ["Branch Manager", "MIS", "Accounts Manager"]
      .filter(Boolean)
      .includes(roleId) // Filter out any false or undefined values
  ) {
    options.push({
      label: "Customer Relationship Officer",
      value: "Customer Relationship Officer",
    });
  }

  if (["MIS", "Accounts Manager"].filter(Boolean).includes(roleId)) {
    options.push({ label: "Branch Manager", value: "Branch Manager" });
  }

  const handleClick = () => {
    if (!comment || !retriggerToRole) {
      setValidationError("Please fill all fields");
    } else {
      setValidationError("");
      handleConfirm();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to Retrigger?
        <Form.Group>
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter Comment"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            required
          />
        </Form.Group>
        Retrigger To
        <Select
          value={options.find((option) => option.value === retriggerToRole)}
          onChange={(selectedOption) =>
            setRetriggerToRole(selectedOption.value)
          }
          options={options}
          placeholder="-- Select Role --"
          isClearable
        />
        <p>{validationError}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleClick}>
          Retrigger
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RetriggerJlgEmiPendingModal;
